import { render, staticRenderFns } from "./basicVisible.vue?vue&type=template&id=27cdb5ea&scoped=true"
import script from "./basicVisible.vue?vue&type=script&lang=js"
export * from "./basicVisible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cdb5ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27cdb5ea')) {
      api.createRecord('27cdb5ea', component.options)
    } else {
      api.reload('27cdb5ea', component.options)
    }
    module.hot.accept("./basicVisible.vue?vue&type=template&id=27cdb5ea&scoped=true", function () {
      api.rerender('27cdb5ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/goodsVisible/basicVisible.vue"
export default component.exports